// @flow
import * as React from "react"
import { Link as RouterLink } from "react-static"

export const Link = ({
  to,
  children,
  className,
  props,
}: {
  to: string,
  children: React.Node,
  className?: string,
  props?: {},
}) =>
  process.env.NO_ROUTER ? (
    <a href={to} {...props} className={className ? className : ""}>
      {children}
    </a>
  ) : (
    <RouterLink to={to} {...props} className={className ? className : ""}>
      {children}
    </RouterLink>
  )



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Link.js